import graphActionCreators from "Areas/Documents/graph/redux/actionCreators";
import documentsSidebarMenuActionCreators from "Areas/Sidebar/Documents/redux/actionCreators";
import { getActiveDocumentId, getObjects, getObjectsInProgress } from "Areas/Sidebar/Documents/redux/selectors";
import { Permissions, security } from "Common/permissions";
import { connect } from "react-redux";
import { getFinalReadOnlyMode } from "../documentDetails/redux/getReadOnlyMode";
import ContentUpload from "./contentUpload";
import actionCreators from "./redux/actionCreators";
import { getInProgress, getSelectedFolderId, getUserContentFiles, getUserContentFolders } from "./redux/selectors";
const canEdit = security.isAllowed([Permissions.DocumentsEdit]);
const mapStateToProps = (state) => ({
    key: getActiveDocumentId(state),
    documentId: getActiveDocumentId(state),
    inProgress: getInProgress(state) || getObjectsInProgress(state),
    documentObjects: getObjects(state),
    canEdit,
    readOnlyMode: getFinalReadOnlyMode(state),
    folders: getUserContentFolders(state),
    selectedFolderId: getSelectedFolderId(state),
    files: getUserContentFiles(state)
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: () => dispatch(documentsSidebarMenuActionCreators.getObjects()),
    onGetFolders: (documentId) => dispatch(actionCreators.getFolders(documentId)),
    onSaveFolder: (folder, files) => {
        dispatch(actionCreators.saveFolder(folder, files, () => {
            dispatch(actionCreators.getFiles(folder.Id, folder.DocumentId));
        }));
    },
    onOpenFolderCreatorPanel: (documentId) => {
        dispatch(actionCreators.setCreateNewFolder(documentId));
    },
    onPhotoSendToGraph: (documentId, url, documentObjects, fromNodeSourceId, fromNodeSourceGroupId) => dispatch(graphActionCreators.appendPhotoToUpdates(documentId, url, documentObjects, fromNodeSourceId, fromNodeSourceGroupId)),
    onTextSendToGraph: (documentId, text, documentObjects, fromNodeSourceId, fromNodeSourceGroupId) => dispatch(graphActionCreators.appendTextToUpdates(documentId, text, documentObjects, fromNodeSourceId, fromNodeSourceGroupId))
});
export default connect(mapStateToProps, mapDispatchToProps)(ContentUpload);
